import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const ShareModal = ({ onClose, onShare }) => {
  const [shareSettings, setShareSettings] = useState({
    includeScores: true,
    includeCriteria: false,
    includeRecommendations: true,
    platform: null
  });

  const platforms = [
  {
    id: 'facebook',
    url: 'https://www.facebook.com',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1935e13f0-1766988251839.png",
    alt: 'Facebook'
  },
  {
    id: 'x',
    url: 'https://www.x.com',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_14a2e6ab2-1771783542267.png",
    alt: 'X (Twitter)'
  },
  {
    id: 'instagram',
    url: 'https://www.instagram.com',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1af73c350-1767779362825.png",
    alt: 'Instagram'
  },
  {
    id: 'tiktok',
    url: 'https://www.tiktok.com',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1a737f06c-1768591160746.png",
    alt: 'TikTok'
  }];


  const handleShare = () => {
    if (onShare) {
      onShare({
        ...shareSettings,
        timestamp: new Date()?.toISOString()
      });
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[200] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-card rounded-xl border border-border w-full max-w-md">
        <div className="p-4 md:p-6 border-b border-border flex items-center justify-between">
          <h2 className="text-xl font-semibold text-foreground">Share Results</h2>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            iconName="X" />
          
        </div>

        <div className="p-4 md:p-6 space-y-6">
          <div className="space-y-3">
            <h3 className="text-sm font-semibold text-foreground">Privacy Settings</h3>
            <Checkbox
              label="Include overall scores"
              description="Show attractiveness scores in shared content"
              checked={shareSettings?.includeScores}
              onChange={(e) => setShareSettings({ ...shareSettings, includeScores: e?.target?.checked })} />
            
            <Checkbox
              label="Include detailed criteria"
              description="Share individual criterion scores"
              checked={shareSettings?.includeCriteria}
              onChange={(e) => setShareSettings({ ...shareSettings, includeCriteria: e?.target?.checked })} />
            
            <Checkbox
              label="Include recommendations"
              description="Share improvement suggestions"
              checked={shareSettings?.includeRecommendations}
              onChange={(e) => setShareSettings({ ...shareSettings, includeRecommendations: e?.target?.checked })} />
            
          </div>

          <div className="space-y-3">
            <h3 className="text-sm font-semibold text-foreground">Share To</h3>
            <div className="grid grid-cols-4 gap-3">
              {platforms?.map((platform) =>
              <a
                key={platform?.id}
                href={platform?.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                  e?.preventDefault();
                  setShareSettings({ ...shareSettings, platform: platform?.id });
                  window.open(platform?.url, '_blank', 'noopener,noreferrer');
                }}
                className={`p-4 rounded-lg border-2 transition-smooth flex items-center justify-center aspect-square hover:scale-105 ${
                shareSettings?.platform === platform?.id ?
                'border-primary bg-primary/5 shadow-lg' : 'border-border hover:border-primary/50'}`
                }>
                
                  <img
                  src={platform?.logo}
                  alt={platform?.alt}
                  className="w-10 h-10 object-contain" />
                
                </a>
              )}
            </div>
          </div>

          <div className="bg-muted/30 rounded-lg p-4 flex items-start gap-3">
            <Icon name="Info" size={18} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
            <p className="text-sm text-muted-foreground">
              Your photos will be shared with the selected privacy settings. You can always delete shared content later.
            </p>
          </div>
        </div>

        <div className="p-4 md:p-6 border-t border-border flex items-center gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            fullWidth>
            
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={handleShare}
            disabled={!shareSettings?.platform}
            iconName="Share2"
            iconPosition="left"
            fullWidth>
            
            Share Now
          </Button>
        </div>
      </div>
    </div>);

};

export default ShareModal;